var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSettingsFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15.331 24H9.313v-2.79a9.384 9.384 0 0 1-1.362-.571l-1.938 1.946-4.252-4.271 1.95-1.96a8.918 8.918 0 0 1-.548-1.328H.378V8.98h2.758c.152-.485.35-.957.576-1.415L1.76 5.606l4.252-4.27L7.951 3.28a9.312 9.312 0 0 1 1.355-.57V0h6.019v2.67c.49.16.959.352 1.415.585l1.911-1.92 4.253 4.271-1.898 1.907c.238.472.443.956.601 1.461h2.771v6.045h-2.797c-.159.472-.35.937-.575 1.375l1.984 1.993-4.253 4.271-1.997-2.006a9.838 9.838 0 0 1-1.422.585v2.756l.013.007Zm-2.953-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSettingsFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/SettingsFilled.c6089bb12d014a86f0662468f1c22d3a.svg";